Jelly.Actions.Add_Infinite_Input = function (Parameters){
	var Debug = false && Jelly.Debug.Debug_Mode;

	if (Debug) {
		Jelly.Debug.Group("Add Infinite Input");
		Jelly.Debug.Log(Parameters);
	};

	var Infinite_Namespace = Parameters.Namespace + "_" + Parameters.Input_Alias + "_" + "Infinite_Input";


	// Get first unclaimed index from 1 
	var Infinite_Index = 0, $Current_Infinite_Input;
	do {
		Infinite_Index++;
		$Current_Infinite_Input = $("#" + Infinite_Namespace + "_" + Infinite_Index);
	}
	while ($Current_Infinite_Input.length);

	// Get wrapper
	var $Infinite_Wrapper = $("#" + Infinite_Namespace + "_" + "Wrapper");

	// Create new input
	if (!Parameters.Element)
		Parameters.Element = "span";

	var $Infinite_Input = $("<" + Parameters.Element + "/>")
		.addClass("Infinite_Input")
		.data("index", Infinite_Index)
		.attr("id", Infinite_Namespace + "_" + Infinite_Index)
		.html("<span class='Jelly_Loading' style='visibility:visible;'></span>")
		.appendTo($Infinite_Wrapper)
	;
	if (Parameters.Class)
		$Infinite_Input.addClass(Parameters.Class);

	// Create new variables
	Parameters.Variables.Action_Namespace = Parameters.Namespace;
	Parameters.Variables.Input_Index = Infinite_Index;

	// if (Debug) {
	// 	console.log(Infinite_Namespace);
	// 	console.log(Infinite_Index);
	// 	console.log("#" + Infinite_Namespace + "_" + "Wrapper");
	// 	console.log($Infinite_Wrapper);
	// 	console.log($Infinite_Input);
	// 	console.log(Parameters.Variables);
	// 	console.log(Parameters.URL + ":" + Jelly.Utilities.Serialize({Values:Parameters.Variables, Token:",", Is_URI:true}));
	// }

	// Fill 
	Jelly.References.Fill({
		Element: $Infinite_Input.get(0),
		URL: Parameters.URL + ":" + Jelly.Utilities.Serialize({Values:Parameters.Variables, Token:",", Is_URI:true}),
		On_Load: Parameters.On_Load,
		Create_Reference: true,
	});

	// Set last index of
	$("#" + Parameters.Namespace + " " + "[name=\"" + Parameters.Input_Alias + "_" + "Last_Index\"]").val(
		$Infinite_Wrapper.find(".Infinite_Input").last().data("index")
	);

	// Figure out count
	var Infinite_Count = $Infinite_Wrapper.find(".Infinite_Input").length;

	// if (Debug) {
	// 	console.log("seconds");
	// 	console.log("#" + Parameters.Namespace + " " + "[name=\"" + Parameters.Input_Alias + "_" + "Last_Index\"]");
	// 	console.log(
	// 		$("#" + Parameters.Namespace + " " + "[name=\"" + Parameters.Input_Alias + "_" + "Last_Index\"]")
	// 	);
	// 	console.log($Infinite_Wrapper.find(".Infinite_Input").last().data("index"));
	// 	console.log(Infinite_Count);
	// 	console.log($("#" + Infinite_Namespace + "_" + "Count"));
	// 	console.log($("#" + Infinite_Namespace + "_" + "Trigger"));
	// }

	// Show/Hide button based on max
	if (Parameters.Max) {
		if (Infinite_Count < Parameters.Max) 
			$("#" + Infinite_Namespace + "_" + "Trigger").show();
		else
			$("#" + Infinite_Namespace + "_" + "Trigger").hide();
	}

	if (Debug)
		Jelly.Debug.End_Group("");
	
	// TODO - not sure if still needed 
	return (Infinite_Index);
};
